import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { NON_DIGITS_PATTERN } from '@shared-constants/pattern-constants';
import { IHttpResponseCostCenter } from '@shared-interfaces/api';

import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'cost-center-lookup',
  templateUrl: './cost-center-lookup.component.html',
  styleUrl: './cost-center-lookup.component.css',
  standalone: false,
})
export class CostCenterLookupComponent implements OnInit, OnDestroy {
  public filter = this.datahub.fb.control('');
  public filteredCostCenters: IHttpResponseCostCenter[] = [];
  public costCenters: IHttpResponseCostCenter[] = [];

  private subscriber = new Subscription();

  constructor(
    public datahub: DatahubService,
    public dialogRef: MatDialogRef<CostCenterLookupComponent>,
    public changeDetectorRef: ChangeDetectorRef,
  ) {
    if (this.datahub.staticData.costCenters.isReady) this.reset();
  }

  reset() {
    this.costCenters = this.datahub.staticData.costCenters.value;
    this.filteredCostCenters = this.costCenters;
  }

  ngOnInit(): void {
    this.subscriber = this.filter.valueChanges.subscribe((value) => {
      if (!value) this.resetFilter();
      if (NON_DIGITS_PATTERN.test(value)) this.filterByName(value);
      else this.filterByNumber(value);
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriber.unsubscribe();
  }

  filterByName(value: string) {
    const regex = new RegExp(value, 'gi');
    this.filteredCostCenters = this.costCenters.filter((x) => regex.test(x.Description));
    this.changeDetectorRef.detectChanges();
  }

  filterByNumber(value: string) {
    const regex = new RegExp(value);
    this.filteredCostCenters = this.costCenters.filter((x) => regex.test(x.CostCtr));
    this.changeDetectorRef.detectChanges();
  }

  resetFilter() {
    this.filteredCostCenters = this.costCenters;
    this.changeDetectorRef.detectChanges();
  }

  handleSelection(cc: IHttpResponseCostCenter) {
    this.datahub.costCenter.setCostCenterValue(cc, true);
    this.dialogRef.close(cc);
    this.changeDetectorRef.detectChanges();
  }
}
